export enum DailyRewardPackageCode {
  Super = 1,
  Mega = 2,
}

export enum DailyRewardPackagesName {
  Super = 'Daily Reward',
  Mega = 'Mega Reward',
}
